import Home from './Home'
import ProdutividadeSetor from './ProdutividadeSetor'
import ProdutividadeSetorPorAnalista from './ProdutividadeSetorPorAnalista'

export const items = [
  {
    path: '/produtividade/home',
    name: 'produtividade/home',
    component: Home
  },
  {
    path: '/produtividade/setor/:setor',
    name: 'produtividade/setor',
    component: ProdutividadeSetor
  },
  {
    path: '/produtividade/analista',
    name: 'produtividadeSetorAnalista',
    component: ProdutividadeSetorPorAnalista
  }
]



// WEBPACK FOOTER //
// ./src/screens/produtividade/config.js